import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { DataStateChangeEventArgs, FilterService, FilterSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations/src';
import { TextBox } from '@syncfusion/ej2-inputs';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription, timer } from 'rxjs';
import { fadeInOut } from '../../shared/helpers/animations';
import { ICustomer, IServiceError } from '../../shared/models/index';
import { DataUtil } from '@syncfusion/ej2-data';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { AuthorizationService, CustomerService, DeviceinventoryService, ExportDataService, SettingsService, StorageManagerService } from '../../shared/services/index';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { AppGlobals } from '../../shared/globals/appGlobals';
import { ExportStatusEnum } from '../../shared/enums/exportStatus.enum';
import { FeatureService } from '../../shared/services/feature.service';

@Component({
  selector: 'app-submission-history',
  templateUrl: './submission-history.component.html',
  styleUrls: ['./submission-history.component.scss'],
  providers: [FilterService],
  animations: [fadeInOut],
  encapsulation: ViewEncapsulation.Emulated
})

export class SubmissionHistoryComponent extends BaseGridComponent implements OnInit, AfterViewInit {

  dataAll: any;
  dataRecent: any;
  data$: Observable<DataStateChangeEventArgs>;
  dataAll$: Observable<DataStateChangeEventArgs>;
  resolverData: any[] | IServiceError;
  formatOptions: Object;
  dataScope: string;
  customer: ICustomer;
  filterSettings: FilterSettingsModel;
  initial = true;
  initialload = false;
  gridComplete = false;
  appVarId: number;
  selectedItemTuple: [number, number];
  activeTab = 'recent';
  tabCounterAll = 0;
  tabCounterRecent = 0;
  downloading = false;
  ExportStatusEnum = ExportStatusEnum;
  downloadTimerSubscription: Subscription;
  downloadInProgress = false;
  submissionhistoryFeatureFlag = false;

  @ViewChild('tabset')
  public tabset: NgbTabset;

  @ViewChild('tooltipObj') tooltipObj: TooltipComponent;

  @ViewChild('downloadLogTemplate', { static: true })
  public toolbarDownloadLogTemplate: any;

  constructor(public service: DeviceinventoryService,
    public storage: StorageManagerService, public router: Router, public activatedRoute: ActivatedRoute, 
    public toastr: ToastrService, public cdref: ChangeDetectorRef, public authorizationService: AuthorizationService, 
    public authenticationService: AuthenticationService, public appGlobals: AppGlobals, 
    public exportDataService: ExportDataService, public settingsService: SettingsService, 
    public customerService: CustomerService, public featureService: FeatureService) {

    super(service, storage, router, activatedRoute, toastr, cdref, authorizationService, authenticationService, 
          appGlobals, exportDataService, settingsService, customerService, featureService);
  }


  ngAfterViewInit(): void {
    this.cdref.detectChanges();
  }


  dataBound(args: any) {

    // The grids in this component have the Menu filter enabled.
    // However, this filter contains an inbuilt autocomplete control
    // The code below creates a custom control to add a plain textbox instead of the autocomplete control.

    const inputObj = [];

    for (let x = 0; x < this.grid.columns.length; x++) {

      let filterBox: any;


      if ((this.grid.columns[x] as any).type === 'string' || (this.grid.columns[x] as any).type === null) {          // create textbox for string type column only
        (this.grid.columns[x] as any).filter.ui = {

          create: (args1) => {

            const flValInput: HTMLElement = document.createElement('input');

            args1.target.appendChild(flValInput);

            inputObj[args1.column.field] = new TextBox({
              floatLabelType: 'Never',
            });
            inputObj[args1.column.field].appendTo(flValInput);

            filterBox = args1.target;
          },
          read: (args2) => {

            let isSkip;
            let skipInput;

            if (args2.column.type === 'string') {
              skipInput = ['>', '<', '=', '!'];

              for (let i = 0, value = args2.element.value; i < value.length; i++) {
                const val = value[i];
                if (skipInput.indexOf(val) > -1) {
                  isSkip = true;
                }
              }
            }

            if (!isSkip) {
              args2.fltrObj.filterByColumn(args2.column.field, args2.operator, args2.element.value);
            } else {

              this.toastr['error']('"< > = !" are not valid filter characters', 'Error', { timeOut: 0, closeButton: true });
            }
          },
          write: (args3) => {
            inputObj[args3.column.field].value = args3.filteredValue || '';
          }
        };
      }
    }

    const header = document.getElementsByClassName('e-headercell')[0];

    if (header) {
      header.classList.add('checkbox-header-manage-di');
    }

    if (this.initial && this.data && this.data.result && this.data.result.length > 0) {

      this.initial = false;

      const firstHeader = document.getElementsByClassName('e-headercell')[0];

      if (firstHeader) {
        firstHeader.classList.add('checkbox-header-manage-di');
      }

    } else {

      (this.grid.getContent().parentElement as any).style.display = '';

      if (this.initial && this.data && this.data.count === 0 && this.grid && this.grid.columns && this.grid.columns.length > 0) {

        this.initial = false;
      }
    }
  }

  private preExecute(state: DataStateChangeEventArgs) {

    if (this.resolverData[0]) {
      this.appDefaults = this.resolverData[0].channelGrids.find(a => a.applicationVariantId === this.appVarId).submissionHistoryGrid;

      this.pageOptions = { pageSize: this.appDefaults.defaultPageSize, pageCount: this.appDefaults.pageCount, pageSizes: this.appDefaults.pageSizes };

    } else {
      this.pageOptions = { pageSize: 25, pageCount: 6, pageSizes: [25, 50, 100] };
    }
    this.state = { skip: state && state.skip ? state.skip : 0, take: this.pageOptions['pageSize'], sorted: [] };
  }
  ngOnInit() {

    this.gridComplete = false;

    this.permissionsConst = this.appGlobals.permissions;

    this.timerInterval = this.serverSettings.hasOwnProperty('LanguageRevalidationInterval') ?
      +this.serverSettings.LanguageRevalidationInterval : 5000;

    this.filterSettings = {
      type: 'Menu',
      operators: {
        stringOperator: [
          { value: 'contains', text: 'contains' },
          { value: 'startsWith', text: 'starts with' },
          { value: 'endsWith', text: 'ends with' },
          { value: 'equal', text: 'equal' }
        ],
        dateOperator: [
          { value: 'contains', text: 'equal' }
        ],
      }
    };

    const currentCustomerStr: string = this.storage.read('currentCustomer');
    if (currentCustomerStr) {
      this.customer = typeof currentCustomerStr === 'object' ? currentCustomerStr : JSON.parse(currentCustomerStr);

      const userguid = this.storage.read('userGuid');
    }

    this.dataScope = this.storage.read('dataScope');

    if (!this.dataScope) {
      this.dataScope = this.customer.applicationVariants[0].applicationVariantName.toLowerCase();
    }

    this.appVarId = this.customer.applicationVariants.find(ap => ap.applicationVariantName.toLowerCase() === this.dataScope.toLowerCase()).applicationVariantId;

    this.downloadInProgress = this.service.submissionHistoryDownloadLogBS.getValue();

    this.formatOptions = { type: 'dateTime', format: 'MM/dd/yyyy hh:mm a' };

    this.toolbar = [{ template: this.toolbarDownloadLogTemplate, id: 'downloadlog' }, 'ColumnChooser'];

    // get data prepared by the resolver
    this.resolverData = this.activatedRoute.snapshot.data['submissionHistoryData'];

    this.preExecute(this.state);

    switch (this.dataScope) {
      case 'eudamed':
        this.sortSettings = { columns: [{ field: 'createDate', direction: 'Descending' }] };
        break;

      case 'china-udi':
        this.sortSettings = { columns: [{ field: 'changeDate', direction: 'Descending' }] };
        break;

      case 'southkorea-udi':
        this.sortSettings = { columns: [{ field: 'changeDate', direction: 'Descending' }] };
        break;

      case 'us-udi':
        this.sortSettings = { columns: [{ field: 'createDate', direction: 'Descending' }] };
        break;
      case 'saudiarabia-udi':
        this.sortSettings = { columns: [{ field: 'createDate', direction: 'Descending' }] };
        break;
      case 'australia-udi':
        this.sortSettings = { columns: [{ field: 'createDate', direction: 'Descending' }] };
        break;
      case 'brazil-udi':
        this.sortSettings = { columns: [{ field: 'createDate', direction: 'Descending' }] };
        break;
    }

    // getting the Most Recent data first. Pass 'false' for the 'All' parameter (last one)
    this.service.getFeatureFlagStatus("submission-history-enhanced").subscribe((response) => {
      this.submissionhistoryFeatureFlag = response;
      if (!this.submissionhistoryFeatureFlag) {
        this.data$ = this.service.getSubmissionHistory(this.customer.customerId, this.dataScope, this.state, this.grid, false);
        this.subscription = this.data$.subscribe((response) => {
          this.gridComplete = false;
          const objects = response;
          this.dataRecent = DataUtil.parse.parseJson((objects as any).ObjectList);
          // this.dataRecent = this.resolverData[1]; // mock
          this.tabCounterRecent = this.dataRecent.length;

          // Most recent data is returned. Now getting data for the All tab. Pass 'true' for the 'All' parameter (last one)

          this.gridComplete = true;
          this.dataAll$ = this.service.getSubmissionHistory(this.customer.customerId, this.dataScope, this.state, this.grid, true);

          this.subscription = this.dataAll$.subscribe(responseAll => {

            const objectsAll = responseAll;
            this.dataAll = DataUtil.parse.parseJson((objectsAll as any).ObjectList);
            // this.dataAll = this.resolverData[1]; // mock
            this.tabCounterAll = this.dataAll.length;

            // set  up the current tab and persist it for a reload
            if (this.storage.read('submissionHistoryTab')) {
              const currentTab = this.storage.read('submissionHistoryTab');

              if (currentTab) {

                this.activeTab = currentTab;

                if (this.tabset) {
                  this.tabset.activeId = currentTab;
                }

              } else {
                if (this.tabset) {
                  this.tabset.activeId = 'recent';
                }
              }
            }
            this.storage.remove('sh-item');
            this.storage.write('submissionHistoryTab', this.activeTab);

            this.deviceCount = this.tabset?.activeId === 'all' ? this.dataAll.length : this.dataRecent.length;

            const firstHeader = document.getElementsByClassName('e-headercell')[0];

            if (firstHeader) {
              firstHeader.classList.add('checkbox-header-submission-history');
            }

            this.storage.write('selectedItems', []);

            this.selectionOptions = { cellSelectionMode: 'Flow', type: 'Multiple', mode: 'Row', checkboxMode: 'Default', checkboxOnly: true };
          });

        });
      } else {
        this.data$ = this.service.getSubmissionHistoryData(this.state, this.grid, this.customer.customerId, this.dataScope, false);

        this.subscription = this.data$.subscribe((response) => {
          this.gridComplete = false;
          this.dataRecent = response;
          var recentCount: number = parseInt(String(response.count), 0);
          this.tabCounterRecent = recentCount;
          this.setDeviceCounter();

          // Most recent data is returned. Now getting data for the All tab. Pass 'true' for the 'All' parameter (last one)
          this.gridComplete = true;
          this.dataAll$ = this.service.getSubmissionHistoryData(this.state, this.grid, this.customer.customerId, this.dataScope, true);

          this.subscription = this.dataAll$.subscribe(responseAll => {
            this.dataAll = responseAll;
            var allCount: number = parseInt(String(responseAll.count), 0);
            this.tabCounterAll = allCount;

            // set  up the current tab and persist it for a reload
            if (this.storage.read('submissionHistoryTab')) {
              const currentTab = this.storage.read('submissionHistoryTab');

              if (currentTab) {

                this.activeTab = currentTab;

                if (this.tabset) {
                  this.tabset.activeId = currentTab;
                }

              } else {
                if (this.tabset) {
                  this.tabset.activeId = 'recent';
                }
              }
            }
            this.storage.remove('sh-item');
            this.storage.write('submissionHistoryTab', this.activeTab);

            this.deviceCount = this.tabset?.activeId === 'all' ? allCount : recentCount;

            const firstHeader = document.getElementsByClassName('e-headercell')[0];

            if (firstHeader) {
              firstHeader.classList.add('checkbox-header-submission-history');
            }

            this.storage.write('selectedItems', []);

            this.selectionOptions = { cellSelectionMode: 'Flow', type: 'Multiple', mode: 'Row', checkboxMode: 'Default', checkboxOnly: true };
          });

        });
      }
    });
    //this.data$ = this.service.getSubmissionHistory(this.customer.customerId, this.dataScope, this.state, this.grid, false);


    // set focus on the invisible div so the firest tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
    this.initTabIndex();
  }
  /**
* Every time the data state changes (resize, reorder, reload, etc.) this event gets triggered
* and originates the grid parameters. The parameter showInColumnChooser should be present
* for all columns in the columnOptions array. Default columns should be set to false to
* prevent the user from hiding them.
* Called from the html on the grid's dataStateChange event
* @param  {DataStateChangeEventArgs} state
* @returns void
*/
  public dataStateChange(state: DataStateChangeEventArgs): void {
    if (this.submissionhistoryFeatureFlag) {
      if (this.tabset?.activeId === 'all') {
        this.dataAll$ = this.service.getSubmissionHistoryData(state, this.grid, this.customer.customerId, this.dataScope, true);
        this.subscription = this.dataAll$.subscribe((response) => {          
          this.dataAll = response;
        });
      } else {
        this.data$ = this.service.getSubmissionHistoryData(state, this.grid, this.customer.customerId, this.dataScope, false);
        this.subscription = this.data$.subscribe((response) => {          
          this.dataRecent = response;
        });
      }
    }
  }

  initTabIndex() {
    (document.activeElement as HTMLElement).blur();

    const main = document.getElementById('firstDiv');

    if (main) {
      main.focus();
    }
  }

  toolbarButtonAccess() {

    this.toolbar = [{ text: 'Download Submission Log', id: 'downloadlog', prefixIcon: 'fal fa-download' }, 'ColumnChooser'];
  }

  /**
 * Triggers when any grid action begins
 * @param  {any} args
 */
  actionBegin(args: any) {

    const type = args.requestType;

    switch (type) {
      case 'paging':
        this.storeSelectedItems();
        break;

      case 'filterbeforeopen':
        break;
      case 'filtering':

        break;

      default:
        break;
    }
  }

  /**
  * Triggers when any grid action taken (sort, page, rows/per page number)
  * Called from the html actionComplete event
  * @param  {any} args
  */
  complete(args: any) {

    switch (args.requestType) {

      case 'refresh':
        this.setDeviceCounter();
        this.toolbarButtonAccess();
        break;
      case 'filtering':
        this.setDeviceCounter();
        this.selectRowsAll(false);
        break;
      case 'paging':
        this.persistSelectedRows();

        if (!this.selectAllChecked && !this.deselectAllChecked) {
          this.persistSelectedRows();
        }

        // if SelectAll is selected - select rows on the page on paging event
        if (this.selectAllChecked) {
          this.selectRowsAll(this.selectAllChecked);
        }

        // if SelectAll is intentionally unchecked - unselect rows - overrides persistance
        if (this.deselectAllChecked) {
          this.selectRowsAll(false);
        }
        break;
      case 'sorting':
        break;
      case 'filterafteropen':

        if (args.columnType === 'date') {
          args.filterModel.dlgDiv.querySelector(
            '.e-datepicker'
          ).ej2_instances[0].format = 'MM/dd/y';
        }
        break;
    }
  }

  toolbarClick(args: ClickEventArgs): void {

    switch (args.item.id) {

      case 'downloadlog':

        this.downloadLog();
        break;
    }
  }

  getDownloadInProgress(): boolean {

    const retVal = this.service.submissionHistoryDownloadLogBS.getValue();

    return retVal;
  }

  downloadLog() {

    let fileName: string;
    let downloadLogTaskGuid;

    const items: object[] = [];

    // Prevent the user from attempting to kick off another Log download in the event they get impatient.
    if (this.service.submissionHistoryDownloadLogBS.getValue()) {
      this.toastr.warning("Please wait, a download is currently in progress.")
      return;
    }

    if (this.selectAllChecked) {

      this.downloadInProgress = true;
      this.service.submissionHistoryDownloadLogBS.next(this.downloadInProgress);

      // generate a filter criteria for the backend to process rows on the backend
      this.queryCriteria = this.generateSelectAllCriteria('downloadlog');

      this.postActionReset();

      // call 1, with or without filter. Get back guid.
      this.service.downloadSubmissionLogAll(this.dataScope, this.queryCriteria, this.tabset?.activeId === 'all').subscribe(response => {

        if (response['isSuccess'] && response['data']) {
          const emptyGuid = '00000000-0000-0000-0000-000000000000';
          downloadLogTaskGuid = response['data'];
          // the loading process has started
          if (downloadLogTaskGuid && downloadLogTaskGuid !== emptyGuid) {

            // Initiate the download process timer
            this.downloadTimerSubscription = timer(0, this.timerInterval).subscribe(() => {

              let responseData;
              let dowloadProgressStatus = 0;

              this.service.getDownloadLogStatus(downloadLogTaskGuid).subscribe(response => {

                // check data if success
                if (response['isSuccess'] && response['data']) {

                  responseData = response['data'];
                  dowloadProgressStatus = responseData['statusCode'];

                  // variable to stop "dancing dots" on the toolbar button
                  this.downloadInProgress = dowloadProgressStatus !== ExportStatusEnum.Completed && dowloadProgressStatus !== ExportStatusEnum.Exception;

                  // if status is either completed or exception stop sending http calls, unsubscribe.
                  if (dowloadProgressStatus === ExportStatusEnum.Completed || dowloadProgressStatus === ExportStatusEnum.Exception) {

                    this.downloadInProgress = false;
                    this.service.submissionHistoryDownloadLogBS.next(this.downloadInProgress);

                    // completed or exception - unsubscribe and reset
                    // file is created or an exception occurred - stop checking
                    if (this.downloadTimerSubscription) {
                      this.downloadTimerSubscription.unsubscribe();
                      this.downloadInProgress = false;
                      this.service.submissionHistoryDownloadLogBS.next(this.downloadInProgress);
                    }

                    if (dowloadProgressStatus === ExportStatusEnum.Completed) {

                      // task completed, get the file from the location
                      this.downloadLogFile(responseData['fileName'], responseData['filePath']);
                    }

                    if (dowloadProgressStatus === ExportStatusEnum.Exception) {

                      this.toastr.error(`Error downloading Submission Log`, '', { timeOut: 0, closeButton: true });
                    }
                  }
                }
              })

            }
            );
          }
          // The user requested an extract for a query that yields no results.
          else if(downloadLogTaskGuid === emptyGuid){
            // Hide the loading indicator
            this.service.submissionHistoryDownloadLogBS.next(false);
            this.toastr.info('No results for the current filter. Please update the filter and try again.', '', { timeOut: 5000, closeButton: true});
          }
        } else {
          this.toastr.error(`Error downloading Validation Log`, '', { timeOut: 0, closeButton: true });
        }

        this.postActionReset();
      });


    } else {

      if (this.selectedItems && this.selectedItems.length) {

        const today = new Date();

        fileName = `SubmissionLog_${ String(today.getFullYear()).padStart(2, '0') }${ String(today.getMonth() + 1).padStart(2, '0') }${ String(today.getDate()).padStart(2, '0') }${ String(today.getHours()).padStart(2, '0') }${ String(today.getMinutes()).padStart(2, '0') }.csv`;

        this.selectedItems = this.storage.read('selectedItems');

        if (this.selectedItems && this.selectedItems.length) {

          this.selectedItems.forEach(i => {

            const item = {};

            item['submissionId'] = i;

            items.push(item);
          });
        }

        if (items.length > 0) {

          const paramsContainer = {
            submissionInputs: items,
            channel: this.dataScope,
            reportFilename: fileName,
            reportFormat: 'CSV'
          };

          this.downloading = true;

          this.service.getSubmissionLog(paramsContainer)
            .subscribe(response => {

              if (response['size'] && response['type']) {

                // IE
                if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                  (window.navigator as any).msSaveOrOpenBlob(response, fileName);
                } else {

                  // non-IE
                  const URL = window.URL || (<any>window).webkitURL;
                  const downloadUrl = URL.createObjectURL(response);
                  const link = document.createElement('a');
                  link.href = downloadUrl;
                  link.download = fileName;
                  link.click();

                  this.downloading = false;
                  this.clearGridSelection();
                }
              } else {

                this.toastr.error(`Error downloading Submission Log`, '', { timeOut: 0, closeButton: true });
              }
            });
        }
      } else {

        this.toastr.warning(`No Submission(s) selected.`, '', { closeButton: true });
      }
    }
  }

  // override the parent because this grid doesn't have an "id" field
  storeSelectedItems() {

    // for some reason getSelectedRecords() returns all visible rows, even if nothing is selected
    // however the getSelectedRows() returns correctly the selected rows but not it the structure we need from the getSelectedRecords()
    // So, need to check the getSelectedRows to make sure that rows have been selected. Looks like Syncfusino bug. When any row is really selected,
    // both function return correct number of rows.

    if (this.grid.getSelectedRows() && this.grid.getSelectedRows().length) {
      const selectedRecords = this.grid.getSelectedRecords();

      if (selectedRecords.length > 0) {

        // add selected records
        selectedRecords.forEach(element => {

          if (!this.selectedItems.includes(element['submissionId'])) {
            this.selectedItems.push(element['submissionId']);
          }
        });
      }

      this.storage.write('selectedItems', this.selectedItems);
    } else {

      // when no rows selected the above block is skipped and the storage is not updated and previously selected rows are persisted.
      let storedSelectedItems = this.storage.read('selectedItems');

      // get records on the page and remove each of them from the storage so they are not persisted
      const records = this.grid.getCurrentViewRecords();

      if (records && records.length) {
        records.forEach(item => {

          const rowIndex = storedSelectedItems.findIndex(x => x === item['submissionId']);

          if (rowIndex >= 0) {
            storedSelectedItems.splice(rowIndex, 1)
          }
        });
      }

      // update the storage
      this.storage.write('selectedItems', storedSelectedItems);
    }
  }

  // override the parent because this grid doesn't have an "id" field
  persistSelectedRows() {

    this.grid.selectRows([]);

    const selectedItemIndexes: number[] = [];

    const selectedItems = this.storage.read('selectedItems');

    if (selectedItems && selectedItems.length > 0) {

      const gridObj = this.grid;

      const records = gridObj.getCurrentViewRecords();

      selectedItems.forEach(item => {

        const row = records.find(r => r['submissionId'] === item);

        if (row) {

          const index = records.indexOf(row);

          if (index >= 0) {
            selectedItemIndexes.push(index);
          }
        }
      });

      if (selectedItemIndexes.length > 0) {

        this.grid.selectRows(selectedItemIndexes);
      }
    }
  }

  tabChanged(event) {

    // variable to initialize the ColumnChooser
    this.initialLoad = true;

    // deselect rows from the previous tab
    this.selectRowsAll(false);

    this.storage.write('submissionHistoryTab', event.nextId);
    this.activeTab = event.nextId;
    this.deviceCount = 0;
    if (this.submissionhistoryFeatureFlag) {
      this.selectedItems = [];
      this.state = {};
      this.preExecute(this.state);

      if (event.nextId === 'all') {
        this.dataAll$ = this.service.getSubmissionHistoryData(this.state, this.grid, this.customer.customerId, this.dataScope, true);
        this.subscription = this.dataAll$.subscribe(responseAll => {
          this.dataAll = responseAll;
          var allCount: number = parseInt(String(responseAll.count), 0);
          this.tabCounterAll = allCount;
          this.deviceCount = allCount;
          this.storage.write('selectedItems', []);
        });
      } else {
        this.data$ = this.service.getSubmissionHistoryData(this.state, this.grid, this.customer.customerId, this.dataScope, false);
        this.subscription = this.data$.subscribe((response) => {
          this.dataRecent = response;
          var recentCount: number = parseInt(String(response.count), 0);
          this.tabCounterRecent = recentCount;
          this.deviceCount = recentCount;
          this.storage.write('selectedItems', []);
        });
      }
    }
    else {
      this.deviceCount = event.nextId === 'all' ? this.dataAll.length : this.dataRecent.length;
      this.storage.write('selectedItems', []);
    }
  }

  itemClicked(data) {

    if (data) {
      this.storage.write('sh-item', data);
      this.router.navigate(['submissions/submissionhistoryitem']);
    }
  }

  itemSubmissionType(data): string {

    let retVal;

    retVal = data.submissionType === 'Basic UDI-DI Update' ? 'model' : 'device';

    return retVal;
  }


  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    // clear the selected items storage
    this.storage.write('selectedItems', []);
  }

}


